var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"id":"input","aria-label":"email","type":"text","name":"email","placeholder":_vm.tEmail,"rules":[_vm.rules.email],"validateOnBlur":_vm.validateOnBlur,"value":_vm.value,"autofocus":_vm.autofocus,"required":"","outlined":"","dense":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }